/* eslint-disable default-param-last */
import { Reducer } from 'redux';
import produce from 'immer';
import { ContractAnalysisTypes, ContractsAnalysisState } from './types';

const REQUEST_INITIAL_STATE = {
  loading: false,
  loaded: false,
  error: false,
};

const INITIAL_STATE: ContractsAnalysisState = {
  contract_analysis: {
    list_contract_analysis: [],
    detailed_contract: null,
    bidding: null,
    currentPage: 1,
    total_entries: 0,
  },
  request: {
    list_contract_analysis: REQUEST_INITIAL_STATE,
    detailed_contract: REQUEST_INITIAL_STATE,
    bidding: REQUEST_INITIAL_STATE,
    validate_contract: REQUEST_INITIAL_STATE,
  },
};
const reducer: Reducer<ContractsAnalysisState> = (state = INITIAL_STATE, { type, result }) => {
  return produce(state, (draft) => {
    switch (type) {
      case ContractAnalysisTypes.GET_CONTRACT_ANALYSIS_REQUEST:
        draft.request.list_contract_analysis = {
          loading: true,
          loaded: false,
          error: false,
        };
        draft.contract_analysis = INITIAL_STATE.contract_analysis;
        break;
      case ContractAnalysisTypes.GET_CONTRACT_ANALYSIS_SUCCESS:
        draft.contract_analysis.list_contract_analysis = result?.data?.data;
        draft.contract_analysis.total_entries = result?.data?.total_entries;
        draft.contract_analysis.currentPage = result?.data?.currentPage;
        draft.request.list_contract_analysis = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case ContractAnalysisTypes.GET_CONTRACT_ANALYSIS_FAILURE:
        draft.request.list_contract_analysis = {
          loading: false,
          loaded: false,
          error: true,
        };
        draft.contract_analysis = INITIAL_STATE.contract_analysis;
        break;
      case ContractAnalysisTypes.DETAILED_CONTRACT_ANALYSIS_REQUEST:
        draft.contract_analysis.detailed_contract =
          INITIAL_STATE.contract_analysis.detailed_contract;
        draft.request.detailed_contract = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case ContractAnalysisTypes.DETAILED_CONTRACT_ANALYSIS_SUCCESS:
        draft.contract_analysis.detailed_contract = result?.data;
        draft.request.detailed_contract = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case ContractAnalysisTypes.DETAILED_CONTRACT_ANALYSIS_FAILURE:
        draft.contract_analysis.detailed_contract =
          INITIAL_STATE.contract_analysis.detailed_contract;
        draft.request.detailed_contract = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      case ContractAnalysisTypes.GET_INFO_BIDDING_REQUEST:
        draft.contract_analysis.bidding = INITIAL_STATE.contract_analysis.bidding;
        draft.request.bidding = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case ContractAnalysisTypes.GET_INFO_BIDDING_SUCCESS:
        draft.contract_analysis.bidding = result?.data;
        draft.request.bidding = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case ContractAnalysisTypes.GET_INFO_BIDDING_FAILURE:
        draft.contract_analysis.bidding = INITIAL_STATE.contract_analysis.bidding;
        draft.request.bidding = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      case ContractAnalysisTypes.VALIDATE_CONTRACT_REQUEST:
        draft.request.validate_contract = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case ContractAnalysisTypes.VALIDATE_CONTRACT_SUCCESS:
        window.location.href = '/validar_contrato';
        draft.request.validate_contract = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case ContractAnalysisTypes.VALIDATE_CONTRACT_FAILURE:
        draft.request.validate_contract = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      default:
    }
  });
};
export default reducer;
